import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CustomButton = styled(Button)({
  textTransform: "none",
  paddingX: 2,
  paddingY: 1,
  backgroundColor: "#103A6D",
  borderRadius: "24px !important",
  color: "#fff",
});

export default function BackButton({ onClick, label = "Back" }) {
  return (
    <CustomButton
      variant="outlined"
      startIcon={<ArrowBackIcon />}
      onClick={onClick}
    >
      {label}
    </CustomButton>
  );
}
